import { useCallback } from 'react';

import { H2 } from '@comeon/ui';

import { Translations } from '~/components/payment/quick-deposit-beta/components-v2/types';
import { TAction, TriggerViewFn } from '~/components/payment/quick-deposit-beta/types';
import {
	textKeysQDAmountScreen,
	UPLOAD_DOC_REDIRECT_CONFIRM
} from '~/components/payment/quick-deposit-beta/utils/constants';
import usePaymentTracking from '~/components/payment-beta/deposit/hooks/use-payment-tracking';

import { CloseButton, HeadWrapper, RoundedButtonSecondary, SubTitle } from './styles';
import { ContentWrapper } from '~/components/payment/quick-deposit-beta/components-v2/deposit-amount/styles';

type Props = {
	addView: (...args: string[]) => TAction;
	setShowKYCMessage: (value: boolean) => void;
	translation: Translations<typeof textKeysQDAmountScreen>;
	updateViews: (...args: ReturnType<TriggerViewFn>[]) => TAction;
};

const NewQDKYCScreen = ({ addView, updateViews, setShowKYCMessage, translation: t }: Props) => {
	const { trackQDEvent } = usePaymentTracking();

	const handleClose = useCallback(() => {
		// Track KYC screen close action
		trackQDEvent({
			pixel_deposit_action: 'click-x-upload-document-popup'
		});
		setShowKYCMessage(false);
	}, [setShowKYCMessage, trackQDEvent]);

	const handleUploadDocumentsClick = () => {
		// Track upload documents button click
		trackQDEvent({
			pixel_deposit_action: 'click-upload-documents'
		});
		updateViews(addView(UPLOAD_DOC_REDIRECT_CONFIRM));
	};

	return (
		<>
			<HeadWrapper>
				<H2 data-at="main-title-upload-documents">{t.MOBILE_DEPOSIT_KYC_MESSAGE_NOT_UPLOADED}</H2>
				<CloseButton className="at-icon-close page-head__close" onClick={handleClose} type="button" />
			</HeadWrapper>
			<ContentWrapper>
				<SubTitle dataAt="sub-title-upload-documents">{t.QD_KYC_MESSAGE}</SubTitle>
				<RoundedButtonSecondary
					smallfont
					onClick={handleUploadDocumentsClick}
					type="submit"
					className="u-relative button u-mb1"
					title="title"
					dataAt="new-mobile-quick-deposit-upload-documents"
				>
					{t.MOBILE_UPLOAD_DOCUMENTS_HEAD_TITLE}
				</RoundedButtonSecondary>
			</ContentWrapper>
		</>
	);
};

export default NewQDKYCScreen;
